export const T = {
  en_GB: {
    noProductsExpectedValue:
      "No products added yet. Use the Custom Portfolio Builder to add products, then the expected value will be available.",
    completeRiskAssessment: "Please complete the risk assessment to see the expected value.",
    enterInvestmentAmount: "Please enter an investment amount to see the expected value.",
    noPortfolioForScore: (score: string) =>
      `No portfolio available for risk score ${score}. Please contact your advisor to see the expected value.`,
    notAvailable:
      "Expected value data is not available for this portfolio. This may be because the calculation API is not running. Please contact your advisor.",
    snapshotMissingMessage:
      "Expected value data needs to be regenerated. Use the Regenerate button above.",
    errorLoading: "Error loading expected value data. Please refresh the page.",
    unavailable: "Expected Value Data Unavailable",
    contactAdvisor: "Please contact your advisor for assistance.",
  },
  nb_NO: {
    noProductsExpectedValue:
      "Ingen produkter lagt til ennå. Bruk Egendefinert porteføljebygger for å legge til produkter, deretter vil forventet avkastning være tilgjengelig.",
    completeRiskAssessment: "Fullfør risikovurderingen for å se forventet avkastning.",
    enterInvestmentAmount: "Angi et investeringsbeløp for å se forventet avkastning.",
    noPortfolioForScore: (score: string) =>
      `Ingen portefølje tilgjengelig for risikoskår ${score}. Kontakt din rådgiver for å se forventet avkastning.`,
    notAvailable:
      "Forventet avkastning er ikke tilgjengelig for denne porteføljen. Dette kan skyldes at beregnings-API-et ikke kjører. Kontakt din rådgiver.",
    snapshotMissingMessage: "Forventet avkastning må regenereres. Bruk Regenerer-knappen over.",
    errorLoading: "Feil ved lasting av forventet avkastning. Oppdater siden.",
    unavailable: "Forventet avkastning ikke tilgjengelig",
    contactAdvisor: "Kontakt din rådgiver for hjelp.",
  },
} as const;
